import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

const manifest = document.createElement("link");
manifest.rel = "manifest";
manifest.type = "application/json";
manifest.href = "/manifest.json";

document.head.append(manifest);

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
